// src/utils/fullmargin.js
// Le profil utilisateur est géré uniquement sur FullMargin (compte unique).
// FullMetrix n'héberge plus de page « Compte » : tout ce qui touche au profil
// renvoie ici.
const RAW_URL =
  (typeof process !== "undefined" && process?.env?.REACT_APP_FULLMARGIN_URL) ||
  (typeof process !== "undefined" && process?.env?.VITE_FULLMARGIN_URL) ||
  "https://fullmargin.net/profil";

function normalize(inputUrl) {
  try {
    const url = new URL(String(inputUrl));
    const pathname = url.pathname && url.pathname !== "/" ? url.pathname : "/profil";
    return `${url.origin}${pathname}`.replace(/\/+$/, "");
  } catch {
    return "https://fullmargin.net/profil";
  }
}

export const FULLMARGIN_PROFILE_URL = normalize(RAW_URL);

// Nouvel onglet : la session FullMetrix reste ouverte derrière.
export function openFullMarginProfile() {
  window.open(FULLMARGIN_PROFILE_URL, "_blank", "noopener,noreferrer");
}
